import script from "./SideBarPlanListItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./SideBarPlanListItem.vue?vue&type=script&setup=true&lang=ts"

import "./SideBarPlanListItem.vue?vue&type=style&index=0&id=0366c846&lang=scss"

const __exports__ = script;

export default __exports__